window.ValetStep3 = {

    init() {

        this.calendar = document.querySelector(
            "[data-valet-delivery-calendar]"
        );

        if (!this.calendar) return;

        this.bind();

        // Restore previously selected date
        if (window.valetBooking.deliveryDate) {

            this.updateSummary(
                window.valetBooking.deliveryDate.toLocaleDateString(
                    "en-SG",
                    {
                        day: "numeric",
                        month: "long",
                        year: "numeric"
                    }
                )
            );

        }

    },

    bind() {

        this.calendar.removeEventListener(
            "calendar:selected",
            this.handleDate
        );

        this.calendar.addEventListener(
            "calendar:selected",
            this.handleDate
        );

    },

    handleDate(event) {

        const selectedDate = event.detail.date;
        const rawDate = event.detail.rawDate;

        window.valetBooking.deliveryDate = rawDate;

        window.ValetStep3.updateSummary(selectedDate);

        const nextButton =
            document.querySelector(
                "[data-booking-next]"
            );

        if (nextButton) {

            nextButton.disabled = false;

        }

    },

    updateSummary(date) {

        document
            .querySelectorAll('[data-summary="crate-delivery"]')
            .forEach(item => {

                item.textContent = date;

            });

    }

};